import styled from 'styled-components';

const StyledArrow = styled.div`
	position: fixed;
	width: 16px;
	height: 16px;
	pointer-events: none;
	z-index: 9999;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export { StyledArrow };
